import React from 'react';

const StatusMessageSection = ({ ticket }) => {
  const getStatusMessage = () => {
    switch (ticket.status) {
      case 'PENDING':
        return (
          <div className="mt-6 p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl border border-orange-500/20 shadow-lg relative before:content-[''] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-orange-500 before:to-orange-400 before:rounded-l-sm">
            <h3 className="text-slate-900 font-bold mb-4 font-poppins flex items-center gap-3 text-lg">
              🕒 Ticket Status: Pending Review
            </h3>
            <p className="text-slate-600 font-poppins leading-relaxed text-base">
              Your ticket is currently in our queue. We process requests in order of priority and submission time. You will receive an email notification when your ticket status changes.
            </p>
          </div>
        );

      case 'IN_PROGRESS':
        if (ticket.category === 'ACCOUNT_MANAGEMENT') {
          return (
            <div className="mt-6 p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border border-blue-500/20 shadow-lg relative before:content-[''] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-blue-500 before:to-blue-400 before:rounded-l-sm">
              <h3 className="text-slate-900 font-bold mb-4 font-poppins flex items-center gap-3 text-lg">
                📝 Action Required: Fill Out Excel Form
              </h3>
              <p className="text-slate-600 mb-6 font-poppins leading-relaxed text-base">
                Please check your email for the Excel form link. You need to complete this form for your account request to proceed.
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="font-poppins text-base">
                  The required Excel form link has been sent to your email address. Please fill it out completely and accurately.
                </p>
              </div>
            </div>
          );
        }
        return null;

      case 'RESOLVED':
        if (ticket.category === 'ACCOUNT_MANAGEMENT') {
          return (
            <div className="mt-6 p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-xl border border-green-500/20 shadow-lg relative before:content-[''] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-green-500 before:to-green-400 before:rounded-l-sm">
              <h3 className="text-slate-900 font-bold mb-4 font-poppins flex items-center gap-3 text-lg">
                ✅ Account Management Request Completed
              </h3>
              <p className="text-slate-600 mb-6 font-poppins leading-relaxed text-base">
                Your account management request has been completed. Please check your email for the Excel form and further instructions.
              </p>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                <p className="font-poppins text-base">
                  The Excel form link and account details have been sent to your email. Please follow the instructions provided in the email.
                </p>
              </div>
              <button
                onClick={() => window.open('https://csm.depedimuscity.com/', '_blank')}
                className="w-full py-4 px-6 rounded-xl font-semibold font-poppins text-base bg-green-600 text-white shadow-lg hover:bg-green-700 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                </svg>
                🌟 Share Your Feedback
              </button>
            </div>
          );
        } else {
          return (
            <div className="mt-6 p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-xl border border-green-500/20 shadow-lg relative before:content-[''] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-green-500 before:to-green-400 before:rounded-l-sm">
              <h3 className="text-slate-900 font-bold mb-4 font-poppins flex items-center gap-3 text-lg">
                🎉 Ticket Resolved Successfully!
              </h3>
              <p className="text-slate-600 mb-6 font-poppins leading-relaxed text-base">
                We're glad we could help! Your feedback is important to us and helps improve our service.
              </p>
              <button
                onClick={() => window.open('https://csm.depedimuscity.com/', '_blank')}
                className="w-full py-4 px-6 rounded-xl font-semibold font-poppins text-base bg-green-600 text-white shadow-lg hover:bg-green-700 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                </svg>
                🌟 Share Your Feedback
              </button>
            </div>
          );
        }

      default:
        return null;
    }
  };

  return getStatusMessage();
};

export default StatusMessageSection;